.root {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  white-space: nowrap;
}
